import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Calendar, Image, Shield, TrendingUp, Menu, X } from 'lucide-react';
import React, { useState } from 'react';

export default function TopNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path: string) => {
    if (path === '/dashboard/content-marketing/' && location.pathname === '/dashboard/content-marketing/') return true;
    if (path !== '/dashboard/content-marketing/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const navItems = [
    { name: 'Dashboard', path: '/dashboard/content-marketing/smDashboard', icon: LayoutDashboard },
    // { name: 'Compose', path: '/dashboard/content-marketing/compose', icon: PenSquare },
    { name: 'Scheduler', path: '/dashboard/content-marketing/calendar', icon: Calendar },
    { name: 'Media Library', path: '/dashboard/content-marketing/media', icon: Image },
    { name: 'Compliance', path: '/dashboard/content-marketing/compliance', icon: Shield },
    { name: 'Marketing Analytics', path: '/dashboard/content-marketing/analytics', icon: TrendingUp },
  ];

  return (
    <div className="tw bg-white border-b border-[#E5E7EB] sticky top-0 z-40 shadow-sm w-full">
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between gap-6">
          {/* Logo/Title */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <div className="w-9 h-9 bg-gradient-to-br from-[#F67570] to-[#F45C56] rounded-lg flex items-center justify-center shadow-sm">
              <span className="text-white font-bold">SS</span>
            </div>
            <div>
              <h1 className="font-semibold text-[#111827]">SocialSync</h1>
              <p className="text-xs text-[#6B7280] hidden sm:block">Social Media Scheduler</p>
            </div>
          </div>

          {/* Desktop Horizontal Navigation */}
          <nav className="hidden lg:flex items-center gap-1 flex-1 justify-end">
            {navItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.path);

              return (
                <div
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={`tw inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all ${
                    active
                      ? 'bg-[#FEF2F2] text-[#F67570] shadow-sm'
                      : 'text-[#6B7280] hover:bg-[#F9FAFB] hover:text-[#111827]'
                  }`}
                >
                  <Icon size={18} />
                  <span>{item.name}</span>
                </div>
              );
            })}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 hover:bg-[#F9FAFB] rounded-lg transition-colors"
          >
            {mobileMenuOpen ? (
              <X size={24} className="text-[#6B7280]" />
            ) : (
              <Menu size={24} className="text-[#6B7280]" />
            )}
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pt-4 border-t border-[#E5E7EB]">
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => {
                const Icon = item.icon;
                const active = isActive(item.path);

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                      active ? 'bg-[#FEF2F2] text-[#F67570]' : 'text-[#6B7280] hover:bg-[#F9FAFB] hover:text-[#111827]'
                    }`}
                  >
                    <Icon size={20} />
                    <span>{item.name}</span>
                  </Link>
                );
              })}
            </nav>
          </div>
        )}
      </div>
    </div>
  );
}
